<template>
    <cadastro-simples-list
        endpoint="categoria-disciplina"
        rota-base="/admin/categoria-disciplina"
        titulo="CATEGORIAS DE DISCIPLINA"
        titulo-singular="Categoria de Disciplina"
        :colunas-extras='[]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
